import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = ccObject

$('.faq-block .feed-faq-category__wrapper').on('click', function () {
  const $this = $(this)
  const id = $this.attr('data-id')
  const block = $this.closest('.faq-block')
  const posts = block.find('.faq-block__posts')
  const categories = block.find('.faq-block__categories')
  const all = block.find('.feed-faq-category')
  const cur = $this.parent()
  const allWrappers = block.find('.feed-faq-category__wrapper')
  const back = block.find('.faq-block__return')

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: {
      _ajax_nonce: object.nonce,
      action: 'cc_get_faq_content',
      id,
    },
    beforeSend: () => {
      posts.addClass('faq-block__posts--loading').append(object.loader)
      allWrappers.prop('disabled', true)
    },
    success: (res) => {
      posts.find('.cc-loader').remove()
      posts.removeClass('faq-block__posts--loading')
      posts.html(res.data.content)
      all.removeClass('feed-faq-category--active')
      cur.addClass('feed-faq-category--active')
      allWrappers.prop('disabled', false)

      if (window.matchMedia('(max-width: 991.98px)').matches) {
        posts.show()
        back.show()
        categories.hide()
      }
    },
  })
})

$(document).on('click', '.faq-block__return', function () {
  const $this = $(this)
  const block = $this.closest('.faq-block')
  const categories = block.find('.faq-block__categories')
  const posts = block.find('.faq-block__posts')

  categories.show()
  $this.hide()
  posts.hide()
})

$(document).on('click', '.feed-faq__title', function () {
  const block = $(this).closest('.faq-block__posts')
  const wrapper = $(this).closest('.feed-faq')
  const content = wrapper.find('.feed-faq__contents')

  const otherWrappers = block.find('.feed-faq').not(wrapper)
  otherWrappers.removeClass('feed-faq--active')
  otherWrappers.find('.feed-faq__contents').slideUp(250)

  wrapper.toggleClass('feed-faq--active')
  content.slideToggle(250)
})
